import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";

import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
// import { CommonService } from 'app/services/common/common.service';

import { HttpTestService } from "app/services/http.service";
// import * as balanceResponse from './../../config/mock/SAPBALANCEENQUIRY.json';
// import * as balanceResponse from './../../../assets/mockJSON/SAPBALANCEENQUIRY.json';
// import * as balanceResponse from './SAPBALANCEENQUIRY.json';

@Component({
  selector: "app-prepaid-balance",
  templateUrl: "./prepaid-balance.component.html",
  styleUrls: ["./prepaid-balance.component.css"],
})
export class PrepaidBalanceComponent implements OnInit {
  prepaidValidation_messages = {
    consumerNumber: [
      {
        type: "required",
        message: "Consumer id is mandatory",
      },
      {
        type: "pattern",
        message: "Consumer id is not valid.",
      },
    ],
    amount: [
      {
        type: "required",
        message: "Please select amount",
      },
    ],
    captcha: [
      {
        type: "required",
        message: "Please enter the above captcha",
      },
    ],
  };

  public errorMsg: string = "";
  public successMsg: string = "";

  prepaidMeterForm: FormGroup;
  public captchaView: string = "";
  public isCaptchaMatched: boolean = true;
  public quiry_sec: boolean = true;
  public view_sec: boolean = false;
  balanceInfo: any;
  public serviceOn: boolean = false;
  public balance: any;
  data: any = [];
  public firstDay: any = ""

  public vendorId: any = "";

  public firstDate: any = ""
  energyConsume: any;

  public enqueryDate: any = this.datePipe.transform(new Date(), 'dd-MM-yyyy')
  public enqueryTime: any = this.datePipe.transform(new Date(), 'h:mm a')

  constructor(
    public formBuilder: FormBuilder,
    public httpService: HttpTestService, // public commonService: CommonService
    public datePipe: DatePipe
  ) {
    let date = new Date();
    this.firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    // let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.firstDate = this.convertDatePickerTimeToMySQLTime(this.firstDay)
    console.log("firstDay ", this.firstDate)

    this.initiateForm();
    this.initiateVariable();
    this.generateCaptcha();

    // let currentDay = this.datePipe.transform(new Date(), 'dd-MM-yyyy')
    // let futureDate = this.datePipe.transform(new Date(new Date().setDate(new Date().getDate()+1)), 'dd-MM-yyyy');

  }

  dateConverter(str) {
    var date = new Date(str);
    let mnth = ("0" + (date.getMonth() + 1)).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
    let hours = ("0" + date.getHours()).slice(-2);
    let minutes = ("0" + date.getMinutes()).slice(-2);
    let seconds = ("0" + date.getSeconds()).slice(-2);
    let year = date.getFullYear();
    return `${year}/${mnth}/${day} ${hours}:${minutes}:${seconds}`
  }

  convertDatePickerTimeToMySQLTime(str) {
    var month, day, year, hours, minutes, seconds;
    var date = new Date(str);
    month = ("0" + (date.getMonth() + 1)).slice(-2);
    day = ("0" + date.getDate()).slice(-2);
    hours = ("0" + date.getHours()).slice(-2);
    minutes = ("0" + date.getMinutes()).slice(-2);
    seconds = ("0" + date.getSeconds()).slice(-2);
    var mySQLDate = [day, month, date.getFullYear()].join("-");

    var mySQLTime = [hours, minutes, seconds].join(":");
    return [mySQLDate, mySQLTime].join(" ");
  }


  initiateVariable() {
    this.captchaView = "";
    this.quiry_sec = true;
    this.view_sec = false;
  }

  initiateForm() {
    this.prepaidMeterForm = this.formBuilder.group({
      consumerNumber: new FormControl(
        "",
        Validators.compose([
          Validators.required,
          // Validators.minLength(7),
          // Validators.maxLength(10),
          // Validators.pattern("^[0-9 ]+$")])),
          Validators.pattern("^[a-zA-Z0-9 ]+$"),
        ])
      ),
      captcha: new FormControl("", Validators.compose([Validators.required])),
    });
  }

  ngOnInit() { }

  randomString = function (len, an) {
    an = an && an.toLowerCase();
    var str = "",
      i = 0,
      min = an == "a" ? 10 : 0,
      max = an == "n" ? 10 : 62;
    for (; i++ < len;) {
      var r = (Math.random() * (max - min) + min) << 0;
      str += String.fromCharCode((r += r > 9 ? (r < 36 ? 55 : 61) : 48));
    }
    return str;
  };

  generateCaptcha = function () {
    var self = this;
    self.captchaView = "";
    var cap = self.randomString(3);
    self.captchaView = cap;
  };

  balenceEnquiry() {
    this.serviceOn = true;
    let sap_param = {
      consumerNumber: this.prepaidMeterForm.value.consumerNumber,
      contract_account: " ",
    };

    let temp_param = {
      ebixWaybillNo: "",
      serviceDate: "",
      cancelReason: "",
      requestedBy: "",
    };

    let date = new Date();
    this.firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    this.firstDate = this.convertDatePickerTimeToMySQLTime(this.firstDay)

    this.httpService.balanceEnquiryRevised(sap_param.consumerNumber).subscribe(
      (success) => {
        console.log("Success...", success["status"]);
        if (success["status"] == 1) {
          this.vendorId = success["vendorId"];
          if (success["vendorId"] == 1) {
            if(!success["vendorData"]){
              this.errorMsg = "Connection No. Not Found";
              this.serviceOn = false;
            }
            else{
              if(success["vendorData"].flag == "T") {
                this.balanceInfo = success["vendorData"].data[0];
  
                if(this.balanceInfo.outstanding1 != null) {
                  this.balance = this.balanceInfo.outstanding1.toFixed(2);
                }
                this.energyConsume = this.balanceInfo.grid_billed_consumed_kwh.toFixed(3)
                this.quiry_sec = false;
                this.view_sec = true;
                this.serviceOn = false;
              }
            }
            
          } else if(success["vendorId"] == 2) {
            this.errorMsg = success["message"];
            this.serviceOn = false;
          }
          else if(this.vendorId == 3) {
            this.errorMsg = success["message"];
            this.serviceOn = false;
          }
          else if(this.vendorId == 4) {
            // this.errorMsg = success["message"];
            console.log(success["vendorId"])
            if(!success["vendorData"]){
              this.errorMsg = "Connection No. Not Found";
              this.serviceOn = false;
            }
            else{
              // if(success["vendorData"].code == 1000) {
              //   this.quiry_sec = false;
              //   this.view_sec = true;
              //   this.serviceOn = false;
              //   this.successMsg = success["vendorData"].message;
              //   this.balanceInfo = success["vendorData"].resource;
              //   console.log(this.balanceInfo.location_id);
              //   // this.balanceInfo = success["vendorData"].data[0];
  
              //   // if(this.balanceInfo.outstanding1 != null) {
              //   //   this.balance = this.balanceInfo.outstanding1.toFixed(2);
              //   // }
              //   // this.energyConsume = this.balanceInfo.grid_billed_consumed_kwh.toFixed(3)
              //   // this.quiry_sec = false;
              //   // this.view_sec = true;
              //   // this.serviceOn = false;
              // }
              console.log("balance check..", success["vendorData"])
              if(!success["vendorData"]){
                this.errorMsg = "Connection No. Not Found";
                this.serviceOn = false;
              }
              else{
                console.log("balance check..", )
                if(success["vendorData"].data) {
                  this.balanceInfo = success["vendorData"].data[0];
                  console.log("balance check..", this.balanceInfo )
                  if(this.balanceInfo.outstanding1 != null) {
                    this.balance = this.balanceInfo.outstanding1.toFixed(2);
                  }
                  this.balanceInfo.grid_closing_kwh = this.balanceInfo.grid_closing_kwh.toFixed(2)
                  this.balanceInfo.grid_opening_kwh = this.balanceInfo.grid_opening_kwh.toFixed(2)
                  this.energyConsume = this.balanceInfo.grid_billed_consumed_kwh.toFixed(2)
                  this.quiry_sec = false;
                  this.view_sec = true;
                  this.serviceOn = false;
                }
              }
            }
           
          }
        } else {
          this.serviceOn = false;
          this.errorMsg = success["message"];
        }
      },
      (error) => { }
    );
  }

  backToForm() {
    this.initiateForm();
    this.initiateVariable();
    this.generateCaptcha();
    this.errorMsg = '';
  }

  onSearchChange(searchValue: string): void {
    if (searchValue.length == 3) {
      if (searchValue == this.captchaView) {
        this.isCaptchaMatched = true;
      } else {
        this.isCaptchaMatched = false;
      }
    } else {
      this.isCaptchaMatched = true;
    }
  }
}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/prepaid-balance/prepaid-balance.component.ts